<template>
  <footer class="footer section">
    <section-content-wrapper>
      <div class="footer-section-wrapper">
        <article class="footer-column">
          <section-title class="footer-column-title"
          :text="'Potrzebujesz więcej informacji,  skontaktuj się z brutto.pl'"
          />
          <div class="footer-column-text-wrapper">
            <a class="footer-column-link heading-font" href="tel:+48226999747">
              <img class="contact-phone-icon" src="@/assets/images/icons/phone-blue-icon.svg" alt="" aria-hidden="true">
              <span>+48 22 699 97 47</span></a>
            <p class="footer-column-text">Zespół brutto.pl jest do Twojej dyspozycji:<br /> od poniedziałku do piątku w godzinach 9:00 - 17:00</p>
          </div>
            <button-open-dialog addingClass="footer-button"></button-open-dialog>
        </article>
        <img class="footer-image" src="@/assets/images/footer-image.png" alt="Człowiek patrzący na tablet" aria-hidden="true">
    </div>
    </section-content-wrapper>
  </footer>
</template>

<script>
import SectionContentWrapper from './common/SectionContentWrapper'
import SectionTitle from './common/SectionTitle'
import ButtonOpenDialog from './common/ButtonOpenDialog.vue'

export default {
  name: 'Footer',
  components: {
    SectionContentWrapper,
    SectionTitle,
    ButtonOpenDialog
  }
}
</script>
